import React, { useRef, useEffect, useState } from "react";
import { message, Table, Upload, Image } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText, formatNum, getRandomStr, isNumber } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { PlusOutlined, DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { useSalesDetailModel } from "../salesDetailModel";
import { ISaleSettlement } from "@/views/sales/salesTypes";
import moment from "moment";
import { salesService } from "@/views/sales/salesService";
import { globalPrompt } from "@/components/message";
import { getBaseRequestUrl, getToken } from "@/utils/constants";
import { importPropsConfig } from "@/utils/importFile";
import { convertRes2Blob } from "@/utils/exportFile";
import { publicService } from "@/views/public/publicService";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import useGlobalModel from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";

//结汇
export function SettlementDrawer() {
    const { settlementVisible: visible, getcurrencySymbol, editFormVal, setSettlementVisible, receiptSettle, settlementStatu } = useSalesDetailModel(({ settlementVisible, editFormVal }) => [settlementVisible, editFormVal]);
    const { resourceAuth } = useGlobalModel(({ resourceAuth }) => [resourceAuth]);
    const formRef = useRef<IYhFormRef>();
    const { getSelectedDictOne, getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);
    const initDataSource: ISaleSettlement = {
        key: getRandomStr(),
        "settleTime": null,
        "settlePrice": 0,
        "ioFlag": 0,  //结汇1
        "settlementTime": null,
        "settlementPrice": 0,
        "exchangeRate": 0,
        isEdit: true
    };

    const [payDataSource, setPayDataSource] = useState<ISaleSettlement[]>([]);  //表格默认值

    useEffect(() => {
        if (visible) {
            console.log(editFormVal)
            formRef.current?.setFieldsValue({
                ...editFormVal,
                createTime: editFormVal.createTime && moment(editFormVal.createTime).format("YYYY-MM-DD"),
                payTime: editFormVal.payTime && moment(editFormVal.payTime).format("YYYY-MM-DD"),
            });
            loadData();
        }
    }, [visible])

    const onCancel = () => {
        setSettlementVisible(false);
    }

    //查询之前记录
    const loadData = async () => {
        let { retData } = await salesService.receiptPage({
            code: editFormVal.code,
            ioFlag: 0,
            "page": {
                "pageSize": 1000,
                "pageNum": 1
            }
        });
        if (retData.records && retData.records.length) {
            setPayDataSource(retData.records.map(item => ({
                ...item,
                key: item.id,
                settleTime: item.settleTime ? moment(item.settleTime) : null,
                settlementTime: item.settlementTime ? moment(item.settlementTime) : null,
                amount: +isNumber(item.exchangeRate) * +formatNum(item.settlementPrice),
                isEdit: !item.settlementPrice || !item.settlementTime || !item.exchangeRate
            })))
        } else {
            setPayDataSource([initDataSource]);
        }
    }

    //表单提交
    const onSubmit = async () => {
        return await receiptSettle(payDataSource.map(item => ({
            ...item,
            key: undefined,
            amount: undefined,
            code: editFormVal.code,
            settleTime: item.settleTime instanceof Object ? item.settleTime.format('YYYY-MM-DD') : null,
            settlementTime: item.settlementTime instanceof Object ? item.settlementTime.format('YYYY-MM-DD') : null,
        })), 1)
    }
    //下载文件
    const downloadFile = async (fileId?: string, fileName?: string) => {
        if (!fileId) return message.warning("文件异常，无法下载查看");
        //pdf开网页预览
        if (fileId.indexOf(".pdf") >= 0) {
            window.open(`${getBaseRequestUrl()}/fsrv/fetch/${fileId}?Authorization=${getToken()}`)
            return;
        }
        try {
            let result = await publicService.downloadFile(fileId);
            convertRes2Blob(result, fileName);
        } catch (error) {
            console.error(error)
        }
    }

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "外贸合同号",
                fieldName: "realCode",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户编码",
                fieldName: "customerCode",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结汇日期",
                fieldName: "payTime",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "合同金额",
                fieldName: "contractAmount",
                prefix: getcurrencySymbol('edit'),
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "信用证号",
                fieldName: "creditCode",
                span: 12,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 12,
                disable: true
            },
        ]
    };

    /**
     * 可编辑table
     */
    const columns = [
        {
            title: '收汇日期',
            width: 120,
            dataIndex: 'settleTime',
            // editable: true,
            editType: "datepicker",
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        },
        {
            title: '收汇币种',
            width: 100,
            dataIndex: 'currency',
            editable: true,
            mustEdit: true,
            editType: "select",
            options: getSelectedDictOne(DictCodeEnmu.CURRENCY),
            render: (text: any) => getTreeNodeName(text)
        },
        {
            title: '收汇金额',
            width: 100,
            dataIndex: 'settlePrice',
            // editable: true,
            render: (text: any, record: any) => `${getTreeNodeValue(record.currency)}${formatNum(text)}`
        },
        {
            title: '结汇日期',
            width: 120,
            dataIndex: 'settlementTime',
            editable: true,
            editType: "datepicker",
            render: (text: any) => text instanceof Object ? text.format('YYYY-MM-DD') : text
        },
        {
            title: '结汇金额',
            width: 100,
            dataIndex: 'settlementPrice',
            editable: true,
            render: (text: any) => `￥${formatNum(text)}`
        },
        {
            title: '结汇汇率',
            width: 100,
            dataIndex: 'exchangeRate',
            editable: true,
        },

        {
            title: '附件',
            // width: 160,
            dataIndex: 'appendixList',
            align: "center",
            render: (fileList: any, record: any, index: number) => {
                return <div>
                    {(fileList ?? []).map((file: any, index: number) => {
                        if ((file.md5.indexOf(".png") > -1 || file.md5.indexOf(".jpg") > -1 || file.md5.indexOf(".gif") > -1 || file.md5.indexOf(".jpeg") > -1)) {
                            return <div key={index}>
                                <Image src={`${getBaseRequestUrl()}/fsrv/fetch/${file.md5}?Authorization=${getToken()}`} style={{ width: "40px", height: "40px", marginRight: "10px" }} />
                                <span style={{ color: "blue", cursor: "pointer" }} onClick={() => downloadFile(file.md5, file.name)}>{file.name}</span>
                            </div>
                        } else {
                            return <div style={{ color: "blue", cursor: "pointer" }} onClick={() => downloadFile(file.md5, file.name)} key={index}>{file.name}</div>
                        }
                    })}
                    <div>
                        <Upload
                            showUploadList={false}
                            className="mr-10 ml-10"
                            {...importPropsConfig(`00`, (file: File & { response: { retData: string } }) => {
                                if (file) {
                                    let dataSource = [...payDataSource];
                                    const item = { ...record };
                                    dataSource.splice(index, 1, {
                                        ...item,
                                        appendixList: [...(item.appendixList ?? []), {
                                            name: file.name,
                                            md5: file?.response.retData,
                                        }]
                                    });
                                    setPayDataSource(dataSource);
                                }
                            })}
                        >
                            <UploadOutlined />
                        </Upload>
                    </div>
                </div>
            }
        },
        {
            align: "center",
            title: '操作',
            width: 100,
            render: (text: any, record: ISaleSettlement) => <div className="flex justify-around">
                <PlusOutlined
                    style={{ fontSize: '18px', cursor: 'pointer' }}
                    onClick={() => setPayDataSource(() => [...payDataSource, initDataSource])}
                />
                {!record.id && <DeleteOutlined
                    style={{ fontSize: '18px', cursor: 'pointer' }}
                    // hidden={record?.id ? true : false}
                    onClick={() => setPayDataSource(() => payDataSource.filter(item => item.key !== record.key))}
                />}
            </div>,
        }
    ]

    const newPayColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISaleSettlement, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col?.rules,
                options: col?.options,
                treeList: col?.treeList,
                editType: col?.editType,
                // editable: col?.editable,
                editable: col.mustEdit ? true : record.isEdit && col?.editable,
                onSelectChange: col?.onSelectChange,
                onTreeSelectChange: col?.onTreeSelectChange,
                onSelectFocus: col?.onSelectFocus,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: ISaleSettlement) => {
        let dataSource: ISaleSettlement[] = [...payDataSource];
        const index = dataSource.findIndex((item) => row.key === item.key);

        row.exchangeRate = +isNumber(row.exchangeRate);
        row.settlementPrice = +formatNum(row.settlementPrice);
        row.amount = +formatNum(row.exchangeRate * row.settlementPrice);
        // if (dataSource[index].settlePrice !== row.settlePrice) {
        //     //用户自己编辑不走计算公式
        //     row.settlePrice = +formatNum(row.settlePrice);
        // } else {
        //     //收汇金额 = 结汇金额 * 结汇汇率
        //     row.settlePrice = +formatNum(row.exchangeRate * row.settlementPrice);
        // }

        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setPayDataSource(dataSource);
    }

    const verify = (next: () => void, pass: boolean) => {
        if (!resourceAuth.find(item => item === ResourceAuthEnum.S_ED_YES)) {
            return globalPrompt('message', { text: '请联系后台分配此权限进行操作', type: 'warning' });
        }
        // if (pass && payDataSource.some(item => !item.settlementTime || !item.settlementPrice))
        //     return globalPrompt('message', { text: '请填写完整结汇信息', type: 'warning' });
        // if (pass && +formatNum(payDataSource.reduce((con, next) => { con += +(next.settlementPrice ?? 0); return con }, 0)) > +formatNum(payDataSource.reduce((con, next) => { con += +(next.settlePrice ?? 0); return con }, 0))) {
        //     return message.warning("结汇金额的合计不可以大于收汇金额的合计")
        // }
        if (!pass && formatNum(payDataSource.reduce((con, next) => { con += +(next.settlePrice ?? 0); return con }, 0)) !== formatNum(payDataSource.reduce((con, next) => { con += +(next.settlementPrice ?? 0); return con }, 0)))
            return globalPrompt('message', { text: '已填写的结汇信息金额经汇率转换后与收汇金额不一致', type: 'warning' });
        next()

    }


    return (
        <YHDrawer
            {...{
                title: '外贸合同财务结汇',
                visible,
                onCancel,
                okText: "确认",
                width: 1000,
                onOk: () => verify(() => onSubmit(), true),
                // footerButs: [{
                //     text: "结汇已完结",
                //     style: { background: "#BDC7FC", color: "#fff" },
                //     onClick: () => verify(() => onSubmit().then(res => {
                //         res && settlementStatu()
                //     }), false)
                // }]
            }}
        >
            <YhForm {...formConfig} />
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newPayColumns as ColumnsType<ISaleSettlement>}
                dataSource={payDataSource}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
            <div className="table-bottom-total">合计:
                <span style={{ marginLeft: "196px" }} className="statu-red">
                    {payDataSource.length > 0 && new Set(payDataSource.map(item => item.currency)).size === 1 && <span>
                        {`${getTreeNodeValue(payDataSource[0].currency)}${formatNum(payDataSource.reduce((con, next) => { con += +(next.settlePrice ?? 0); return con }, 0))}`}
                    </span>}
                </span>
                <span className="statu-red" style={{ marginLeft: "174px" }}>{`￥${formatNum(payDataSource.reduce((con, next) => { con += +(next.settlementPrice ?? 0); return con }, 0))}`}</span>
            </div>
        </YHDrawer>
    )
}
